import React from 'react';
import clsx from 'clsx'; // Optional: helps cleanly manage conditional classNames

export function Button({
  children,
  onClick,
  className = '',
  variant = 'default',
  type = 'button',
  disabled = false,
  ...props
}) {
  const baseStyles =
    'inline-flex items-center justify-center px-4 py-2 rounded-2xl font-medium text-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    default: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 dark:bg-blue-500 dark:hover:bg-blue-600',
    outline:
      'border border-gray-300 text-gray-700 hover:bg-gray-100 focus:ring-gray-300 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-700',
    destructive:
      'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 dark:bg-red-500 dark:hover:bg-red-600',
    ghost:
      'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-300 dark:text-gray-300 dark:hover:bg-gray-700',
  };

  const appliedVariant = variants[variant] || variants.default;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(baseStyles, appliedVariant, className)}
      {...props}
    >
      {children}
    </button>
  );
}
